<template>
	<div class="ccard">
		<div class="ccard-front" :style="style">
			<svg class="ccard-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">
				<path :fill="style.color" d="M450.207,158.897c15.007,0,26.483-11.476,26.483-26.483v-8.828h8.828c15.007,0,26.483-11.476,26.483-26.483V79.448c0-3.531-2.648-7.062-6.179-8.828L258.648,0c-1.766,0-3.531,0-5.297,0L6.179,70.621C2.648,72.386,0,75.917,0,79.448v17.655c0,15.007,11.476,26.483,26.483,26.483h8.828v8.828c0,15.007,11.476,26.483,26.483,26.483h8.828v264.828h-8.828c-15.007,0-26.483,11.476-26.483,26.483v8.828h-8.828C11.476,459.034,0,470.51,0,485.517v17.655C0,508.469,3.531,512,8.828,512h494.345c5.297,0,8.828-3.531,8.828-8.828v-17.655c0-15.007-11.476-26.483-26.483-26.483h-8.828v-8.828c0-15.007-11.476-26.483-26.483-26.483h-8.828V158.897H450.207z M26.483,105.931c-5.297,0-8.828-3.531-8.828-8.828V86.51L256,17.655l238.345,67.972v11.476c0,5.297-3.531,8.828-8.828,8.828h-17.655H44.138H26.483z M485.517,476.69c5.297,0,8.828,3.531,8.828,8.828v8.828H17.655v-8.828c0-5.297,3.531-8.828,8.828-8.828h17.655h423.724H485.517z M450.207,441.379c5.297,0,8.828,3.531,8.828,8.828v8.828H52.966v-8.828c0-5.297,3.531-8.828,8.828-8.828h17.655h70.621h70.621h70.621h70.621h70.621H450.207z M88.276,423.724V158.897h52.966v264.828H88.276z M211.862,194.207v229.517h-52.966V194.207H211.862z M158.897,176.552v-17.655h52.966v17.655H158.897z M229.517,423.724V158.897h52.966v264.828H229.517z M353.103,194.207v229.517h-52.966V194.207H353.103z M300.138,176.552v-17.655h52.966v17.655H300.138z M370.759,423.724V158.897h52.966v264.828H370.759z M432.552,141.241h-70.621H291.31H220.69h-70.621H79.448H61.793c-5.297,0-8.828-3.531-8.828-8.828v-8.828h406.069v8.828c0,5.297-3.531,8.828-8.828,8.828H432.552z"/>
				<path :fill="style.color" d="M114.759,176.552c-5.297,0-8.828,3.531-8.828,8.828V291.31c0,5.297,3.531,8.828,8.828,8.828s8.828-3.531,8.828-8.828V185.379C123.586,180.083,120.055,176.552,114.759,176.552z"/>
				<path :fill="style.color" d="M114.759,317.793c-5.297,0-8.828,3.531-8.828,8.828v70.621c0,5.297,3.531,8.828,8.828,8.828s8.828-3.531,8.828-8.828v-70.621C123.586,321.324,120.055,317.793,114.759,317.793z"/>
				<path :fill="style.color" d="M256,247.172c-5.297,0-8.828,3.531-8.828,8.828v141.241c0,5.297,3.531,8.828,8.828,8.828s8.828-3.531,8.828-8.828V256C264.828,250.703,261.297,247.172,256,247.172z"/>
				<path :fill="style.color" d="M256,176.552c-5.297,0-8.828,3.531-8.828,8.828v35.31c0,5.297,3.531,8.828,8.828,8.828s8.828-3.531,8.828-8.828v-35.31C264.828,180.083,261.297,176.552,256,176.552z"/>
				<path :fill="style.color" d="M397.241,176.552c-5.297,0-8.828,3.531-8.828,8.828v211.862c0,5.297,3.531,8.828,8.828,8.828c5.297,0,8.828-3.531,8.828-8.828V185.379C406.069,180.083,402.538,176.552,397.241,176.552z"/>
				<path :fill="style.color" d="M256,35.31c-15.007,0-26.483,11.476-26.483,26.483S240.993,88.276,256,88.276s26.483-11.476,26.483-26.483S271.007,35.31,256,35.31z M256,70.621c-5.297,0-8.828-3.531-8.828-8.828c0-5.297,3.531-8.828,8.828-8.828s8.828,3.531,8.828,8.828C264.828,67.09,261.297,70.621,256,70.621z"/>
			</svg>
			<span class="ccard-numb">{{number}}</span>
			<span class="ccard-name">{{name}}</span>
			<span class="ccard-date">{{date}}</span>
			<span class="ccard-bank">{{bank}}</span>
		</div>
		<div class="ccard-back">
			<span class="ccard-code">{{code}}</span>
		</div>
	</div>
</template>

<script>

	function getCorrectTextColor(hex) {
		
		var hexToR = h => parseInt((cutHex(h)).substring(0,2),16)
		var hexToG = h => parseInt((cutHex(h)).substring(2,4),16)
		var hexToB = h => parseInt((cutHex(h)).substring(4,6),16)
		var cutHex = h => (h.charAt(0) == '#') ? h.substring(1,7):h

		var hRed = hexToR(hex);
		var hGreen = hexToG(hex);
		var hBlue = hexToB(hex);

		return (((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000) > 130 ? '#000000' : '#ffffff'	
	}

	function generate() {

		var hexValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e'];

		function populate(a) {
			for ( var i = 0; i < 6; i++ ) {
				var x = Math.round( Math.random() * 14 );
				var y = hexValues[x];
				a += y;
			}
			return a;
		}

		var newColor1 = populate('#');
		var newColor2 = populate('#');
		var angle = Math.round( Math.random() * 360 );

		return {
			color: getCorrectTextColor(newColor1),
			background: "linear-gradient(" + angle + "deg, " + newColor1 + ", " + newColor2 + ")"
		}
	}

	export default {

		props: [ 'number', 'name', 'date', 'code', 'bank'],

		name: 'Card',

		data () {
			return {
				style: generate()

			}
		},

		computed: {
			n(){
				return this.number.match(/(.|[\r\n]){1,4}/g)
			}
		}
	}
</script>